import { render, staticRenderFns } from "./SeatingAreaSettings.vue?vue&type=template&id=68c0d12a"
import script from "./SeatingAreaSettings.vue?vue&type=script&lang=js"
export * from "./SeatingAreaSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports